export default "__VITE_ASSET__BGtfPcOn__"